class EWGContaminantCategories extends HTMLElement {
  constructor() {
    super()
    this.handleReady = this.handleReady.bind(this)
    this.handleLoading = this.handleLoading.bind(this)
    this.handleUnavailable = this.handleUnavailable.bind(this)
  }

  connectedCallback() {
    this.list = this.querySelector('.ewg-contaminant-categories__list')
    this.slider = this.querySelector('splide-slider')
    this.cardTemplate = this.list?.querySelector('.ewg-contaminant-categories__card')
    document.addEventListener('wd:ewg-ready', this.handleReady)
    document.addEventListener('wd:ewg-loading', this.handleLoading)
    document.addEventListener('wd:ewg-empty', this.handleUnavailable)
    document.addEventListener('wd:ewg-error', this.handleUnavailable)

    const store = window.WDEwgReportStore
    if (!store) return
    store.init().then(state => {
      if (state?.information?.contaminantTypeCounts?.length) {
        this.classList.remove('loading')
        this.ariaBusy = 'false'
        this.render(state.information.contaminantTypeCounts)
        return
      }
      this.handleUnavailable()
    })
  }

  disconnectedCallback() {
    document.removeEventListener('wd:ewg-ready', this.handleReady)
    document.removeEventListener('wd:ewg-loading', this.handleLoading)
    document.removeEventListener('wd:ewg-empty', this.handleUnavailable)
    document.removeEventListener('wd:ewg-error', this.handleUnavailable)
  }

  handleLoading(event) {
    const isLoading = event.detail?.isLoading !== false
    this.classList.toggle('loading', isLoading)
    this.ariaBusy = isLoading ? 'true' : 'false'
  }

  handleReady(event) {
    this.classList.remove('loading')
    this.ariaBusy = 'false'
    this.render(event.detail?.information?.contaminantTypeCounts)
  }

  handleUnavailable() {
    this.classList.remove('loading')
    this.ariaBusy = 'false'
  }

  render(counts) {
    if (!this.list || !this.cardTemplate || !Array.isArray(counts) || !counts.length) return

    const fragment = document.createDocumentFragment()
    counts.forEach(item => {
      const card = this.cardTemplate.cloneNode(true)
      const title = card.querySelector('.ewg-contaminant-categories__card-title')
      const count = card.querySelector('.ewg-contaminant-categories__count')
      if (title) title.textContent = item.contaminantTypeEn || ''
      if (count) count.textContent = item.contaminantCount ?? ''
      fragment.appendChild(card)
    })

    this.list.replaceChildren(fragment)
    const slider = this.slider?.slider
    if (slider) {
      window.requestAnimationFrame(() => {
        slider.refresh()
        slider.go(0)
      })
    }
  }
}

if (!customElements.get('ewg-contaminant-categories')) {
  customElements.define('ewg-contaminant-categories', EWGContaminantCategories)
}
